import PropTypes from "prop-types";
import Avatar from "@shared/v2/Avatar";
import Typography from "@shared/v2/Typography";
import { ArrowRightSolidV6 } from "@shared/v2/Icomoon";
import { useIsPlace } from "../../reducers/layoutReducer/selectors";

const ReviewCard = ({ review }) => {
  const isPlace = useIsPlace();
  return (
    <button
      className="tw-min-w-[468px] tw-bg-white tw-shadow-card tw-p-[32px] tw-rounded-[16px] tw-border-solid tw-border-gray-5 tw-border-[1px] tw-flex tw-flex-col tw-justify-between tw-gap-[16px] tw-group"
      type="button"
      onClick={() => {
        if ((isPlace && review.placeUrl) || (!isPlace && review.brivityUrl)) {
          if (review.replace) {
            window.location.assign(isPlace ? review.placeUrl : review.brivityUrl);
          } else {
            window.open(isPlace ? review.placeUrl : review.brivityUrl, "_blank");
          }
        }
      }}
    >
      <div className="tw-flex tw-flex-col tw-gap-[16px]">
        <div className="tw-flex tw-items-center tw-gap-[12px]">
          <Avatar src={review.user.avatarUrl} alt={review.user.name} size="large" />
          <div className="tw-flex tw-flex-col tw-text-left">
            <Typography variant="headline3">{review.user.name}</Typography>
            <Typography variant="body-m" className="tw-text-[#979797]">
              {review.user.role}
            </Typography>
          </div>
        </div>
        <div className="tw-text-16d tw-leading-[150%] tw-text-left">&ldquo;{review.content}&rdquo;</div>
      </div>
      <div className="tw-overflow-hidden tw-min-h-[21px] tw-h-[21px]">
        <h3 className="tw-transition-transform tw-duration-500 group-hover:tw-translate-y-[-21px] tw-m-0 tw-text-16d tw-text-left tw-font-bold tw-uppercase tw-text-gray-50 tw-tracking-[2px]">
          On {review.source}
        </h3>
        <h3 className="tw-transition-transform tw-duration-500 group-hover:tw-translate-y-[-21px] tw-m-0 tw-text-16d tw-text-left tw-font-bold tw-uppercase tw-text-gray-50 tw-tracking-[2px] tw-flex tw-items-center tw-gap-[6px] tw-text-theme-primary">
          Learn About {review.source} <ArrowRightSolidV6 size="l" className="tw-mb-[2px]" />
        </h3>
      </div>
    </button>
  );
};

ReviewCard.propTypes = {
  review: PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      avatarUrl: PropTypes.string.isRequired,
    }).isRequired,
    replace: PropTypes.bool,
    placeUrl: PropTypes.string.isRequired,
    brivityUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default ReviewCard;
